app.run(['$rootScope', '$state', '$stateParams', '$location', '$window', function ($rootScope, $state, $stateParams, $location, $window) {

    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;

    let fixedScrollID = null;
    let lastStateName = "";
    let lastStateParams = {};

    $rootScope.$on('$stateChangeStart', function (event, state, stateParams) {
        let currentFixedScrollID = null;

        if (stateParams && stateParams.value_0 === "solution" && stateParams.value_1) {
            if (stateParams.value_1 === "kitchen") {
                if (stateParams.value_2) {
                    currentFixedScrollID = "kitchen_" + stateParams.value_2;
                }
            } else {
                currentFixedScrollID = stateParams.value_1;
            }
            currentFixedScrollID = currentFixedScrollID ? "solution_category_" + currentFixedScrollID : null;
        }
        const stateName = state && state.name ? state.name : "";
        if (!currentFixedScrollID || currentFixedScrollID !== fixedScrollID) {
            let isSamePath = lastStateName.includes(stateName) || stateName.includes(lastStateName);
            if (isSamePath) {
                for (let key in stateParams) {
                    if (lastStateParams[key] && lastStateParams[key] !== stateParams[key]) {
                        isSamePath = false;
                    }
                }
            }
            if (isSamePath) {
                setTimeout(function () {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }, 1)
            } else {
                window.scrollTo({top: 0, behavior: 'instant'});
            }
        }
        fixedScrollID = currentFixedScrollID;
        lastStateName = stateName;
        lastStateParams = stateParams;

        const $popovers = $("[handle-popover]")
        $popovers.popover('hide');
    });

    $rootScope.onKeyDown = function (event) {
        $rootScope.$broadcast("key_down", {event: event});
    };

    $rootScope.onDocumentClick = function (event) {
        $rootScope.$broadcast("document_click", {event: event});
    };

    document.body.addEventListener('click', function (mouseEvent) {
        function normalizeHref(href) {
            if (!href) {
                return "";
            }
            href = href.split("?")[0].split("#")[0];
            if (href.slice(-1) !== "/") {
                href += "/";
            }
            return href;
        }

        if (mouseEvent && mouseEvent.target) {
            const targetHref = normalizeHref(mouseEvent.target.href);
            if (targetHref) {
                const currentHref = window.location ? normalizeHref(window.location.href) : null;
                if (currentHref === targetHref) {
                    $rootScope.$broadcast("current_page_clicked");
                }
            }
        }
    }, true);

    $rootScope.console = console;

    // track pageview on state change
    $rootScope.$on('$stateChangeSuccess', function (event) {
        $rootScope.service.tracking.track_event("Page View", $location.path());
        const $popovers = $("[handle-popover]")
        $popovers.popover('hide');
    });

    const body = $('body');

    body.on('focus', 'input[type=number]', function (e) {
        $(this).on('wheel.disableScroll', function (e) {
            e.preventDefault()
        })
    })
    body.on('blur', 'input[type=number]', function (e) {
        $(this).off('wheel.disableScroll')
    })


}]);